// extracted by mini-css-extract-plugin
export default {"closeIcon":"closeIcon__Afrb+","lightButton":"lightButton__2lfZ1"};